import { Mail, MapPin, Phone } from 'lucide-react';

interface FooterProps {
  onNavigate?: (page: string, params?: any) => void;
}

export function Footer({ onNavigate }: FooterProps) {
  const handleClick = (page: string, params?: any) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate(page, params);
    }
  };

  return (
    <footer className="bg-gray-900 text-white" role="contentinfo">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">SHANGHAI DAOCHIN MECHANICAL EQUIPMENT CO., LTD.</h3>
            <p className="text-gray-400 mb-2">
              Professional industrial parts supplier with 20 years of experience, providing high-quality engineering parts and mechanical equipment.
            </p>
            <p className="text-gray-500 text-sm">
              Abbr: DCH
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="#about" onClick={handleClick('About Us')} className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#products" onClick={handleClick('Product')} className="text-gray-400 hover:text-white transition-colors">
                  Products
                </a>
              </li>
              <li>
                <a href="#news" onClick={handleClick('News')} className="text-gray-400 hover:text-white transition-colors">
                  News
                </a>
              </li>
              <li>
                <a href="#contact" onClick={handleClick('Contact Us')} className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-xl font-bold mb-4">Products</h3>
            <ul className="space-y-2">
              <li>
                <a href="#products?category=hydraulic-parts" onClick={handleClick('Product', { category: 'hydraulic-parts' })} className="text-gray-400 hover:text-white transition-colors">
                  Hydraulic Parts
                </a>
              </li>
              <li>
                <a href="#products?category=engine-parts" onClick={handleClick('Product', { category: 'engine-parts' })} className="text-gray-400 hover:text-white transition-colors">
                  Engine Parts
                </a>
              </li>
              <li>
                <a href="#products?category=structural-parts" onClick={handleClick('Product', { category: 'structural-parts' })} className="text-gray-400 hover:text-white transition-colors">
                  Structural Parts
                </a>
              </li>
              <li>
                <a href="#products?category=electrical-parts" onClick={handleClick('Product', { category: 'electrical-parts' })} className="text-gray-400 hover:text-white transition-colors">
                  Electrical Parts
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <address className="not-italic">
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                  <MapPin size={20} className="flex-shrink-0 mt-1" aria-hidden="true" />
                <span className="text-gray-400">
                    NO.1990-1, Jinbi Road, Fengxian District, Shanghai City, China
                </span>
              </li>
              <li className="flex items-center gap-2">
                  <Phone size={20} aria-hidden="true" />
                  <a href="tel:+864008821928" className="text-gray-400 hover:text-white transition-colors">
                    +86 400-882-1928
                  </a>
              </li>
              <li className="flex items-center gap-2">
                  <Mail size={20} aria-hidden="true" />
                  <a href="mailto:dch-equips@outlook.com" className="text-gray-400 hover:text-white transition-colors">
                    dch-equips@outlook.com
                  </a>
              </li>
            </ul>
            </address>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2026 SHANGHAI DAOCHIN MECHANICAL EQUIPMENT CO., LTD. All rights reserved.</p>
          <p className="mt-2 text-sm">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
              ICP License: 沪ICP备2026000796号
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
